import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ToneOfVoiceAnalyzerPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ToneOfVoiceAnalyzerPopup" */ './Container'),
  'popup'
);
